var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contentMain"},[_c('div',{staticClass:"content"},[_c('img',{staticStyle:{"width":"500px","height":"500px","text-align":"center"},attrs:{"src":require("../../assets/construction.png"),"alt":""}}),_c('div',{staticClass:"text"},[_vm._v("建设中")])])])
}]

export { render, staticRenderFns }